export const ScheduleStatusType = ['Open', 'Confirmed', 'Unconfirm', 'UnAllocated'];